import { Dispatch, SetStateAction } from 'react'
import styled, { CSSObject } from '@emotion/styled'
import {
  FulfillmentDateContainer,
  FulfillmentDatePicker
} from '../../FulfillmentDatePicker'
import { addDays } from 'date-fns'

type Props = {
  tempSelectedFulfillmentDate: Date
  setTempSelectedFulfillmentDate: Dispatch<SetStateAction<Date>>
  maxDaysInAdvance: number
}

const StoreSortCalendar = ({
  tempSelectedFulfillmentDate,
  setTempSelectedFulfillmentDate,
  maxDaysInAdvance
}: Props) => {
  return (
    <Container>
      <FulfillmentDateContainer newFulfillmentModal={true}>
        <FulfillmentDatePicker
          selected={tempSelectedFulfillmentDate}
          onChange={(date) =>
            setTempSelectedFulfillmentDate(new Date(date || ''))
          }
          minDate={new Date()}
          maxDate={new Date(addDays(new Date(), maxDaysInAdvance))}
          placeholderText='Date'
          dateFormat='dd/MM/yyyy'
          forceShowMonthNavigation={true}
          newFulfillmentModal={true}
          todayButton={'Today'}
        />
      </FulfillmentDateContainer>
    </Container>
  )
}

const Container = styled.div(
  ({ theme }): CSSObject => ({
    borderRadius: theme.borderRadius,
    border: '1px #D9D9D9 solid'
  })
)

export default StoreSortCalendar
